import React from 'react';
import { CreateInventoryFormPanel } from './FormLayout';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import { asset_status_options, yes_no_options } from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';
import FormFieldItem from "./FormLayout";

const Generator = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    systemType,
    setSystemType,
    generatorType,
    setGeneratorType,
    generatorSubtype,
    setGeneratorSubtype,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    maxDate,
}) => {

    const system_type_options = [
        { value: 0, label: "Comfort Cooling" },
        { value: 1, label: "Process Cooling" },
        { value: 2, label: "Refrigeration" }
    ];

    const generator_type_options = [
        { value: 0, label: "Diesel" },
        { value: 1, label: "Electric" },
        { value: 2, label: "Gas" },
        { value: 3, label: "Natural Gas" },
        { value: 4, label: "Portable Industrial" },
        { value: 5, label: "Solar" },
        { value: 6, label: "Wind" }
    ];

    const generator_subtype_options = [
        { value: 0, label: "Continuous" },
        { value: 1, label: "Standby" }
    ];

    const show_generator_subtypes = (
        generatorType === 0
        || generatorType === 1
        || generatorType === 2
        || generatorType === 3
        || generatorType === 4
    );

    const custom_width = show_generator_subtypes ? 4 : 6;

    return (
        <CreateInventoryFormPanel enabled={false}>
            <FormFieldItem>
                <Select
                    value={newPurchaseAquisition}
                    label="Is this a new purchase / acquisition?"
                   
                    options={yes_no_options}
                    onChange={e => setNewPurchaseAquisition(e.target.value)}
                />
            </FormFieldItem>
            <LocationDropdown
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={setLocation}
                onChangeSubLocation={setSubLocation}
            />
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={!name}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required
                    value={assetStatus}
                    label="Asset Status"
                   
                    options={asset_status_options}
                    onChange={e => setAssetStatus(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Tag Number"
                    value={tagNumber}
                    onChange={e => setTagNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Serial Number"
                    value={serialNumber}
                    onChange={e => setSerialNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={systemType}
                    label="System Type"
                   
                    options={system_type_options}
                    onChange={e => setSystemType(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={generatorType}
                    label="Generator Type"
                   
                    options={generator_type_options}
                    onChange={e => setGeneratorType(e.target.value)}
                />
            </FormFieldItem>
            {show_generator_subtypes && (
                <FormFieldItem>
                    <Select
                        value={generatorSubtype}
                        label={`${generator_type_options[generatorType].label} Type`}
                       
                        options={generator_subtype_options}
                        onChange={e => setGeneratorSubtype(e.target.value)}
                    />
                </FormFieldItem>
            )}
            <FormFieldItem>
                <DateInput
                    date={acquisitionDate}
                    onChange={date => setAquisitionDate(date)}
                    label="Acquisition Date *"
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={disbursementDate}
                    onChange={date => setDisbursementDate(date)}
                    label="Disbursement Date"
                   
                    disabled
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={installDate}
                    onChange={date => setInstallDate(date)}
                    label="Install Date *"
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    multiLine
                    label="Location On Site"
                    value={locationOnSite}
                    onChange={e => setLocationOnsite(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={manufacturer}
                    label="Manufacturer"
                   
                    options={manufacturers}
                    onChange={e => setManufacturer(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    date={manufactureDate}
                    onChange={date => setManufactureDate(date)}
                    label="Manufacturer Date"
                   
                    maxDate={maxDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Model Number"
                    value={modelNumber}
                    onChange={e => setModelNumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={modelYear}
                    label="Model Year"
                   
                    options={years}
                    onChange={e => setModelYear(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Brand"
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="PO Number"
                    value={poNumber}
                    onChange={e => setPONumber(e.target.value)}
                   
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={lifeTime}
                    label="Expected Lifetime (years)"
                   
                    options={lifeTimeOptions}
                    onChange={e => setLifeTime(e.target.value)}
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
    );
};

Generator.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    systemType: PropTypes.string.isRequired,
    setSystemType: PropTypes.func.isRequired,
    generatorType: PropTypes.string.isRequired,
    setGeneratorType: PropTypes.func.isRequired,
    generatorSubtype: PropTypes.string.isRequired,
    setGeneratorSubtype: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default Generator;
